import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { TailSpin } from 'react-loader-spinner';
import { FaReact } from 'react-icons/fa';
import { CommonLoaderProps } from '../types/common.types';

const ReactLogoIcon = FaReact as unknown as React.ComponentType<{ size?: number }>;

const CommonLoader: React.FC<CommonLoaderProps> = ({
  text = 'Loading...',
  fullScreen = false,
  size = 84,
}) => {
  return (
    <Box
      sx={{
        minHeight: fullScreen ? '100vh' : 'auto',
        width: '100%',
        display: 'grid',
        placeItems: 'center',
        backgroundColor: fullScreen ? 'rgba(255, 255, 255, 0.88)' : 'transparent',
      }}
    >
      <Stack alignItems="center" spacing={1.5}>
        <Box sx={{ position: 'relative', width: size, height: size, display: 'grid', placeItems: 'center' }}>
          <TailSpin
            visible
            height={size}
            width={size}
            color="#2F7E8E"
            ariaLabel="app-loader"
          />
          <Box
            sx={{
              position: 'absolute',
              inset: 0,
              display: 'grid',
              placeItems: 'center',
              color: '#2F7E8E',
            }}
          >
            <ReactLogoIcon size={Math.max(26, Math.round(size * 0.34))} />
          </Box>
        </Box>

        <Typography fontWeight={700} sx={{ color: '#2F7E8E' }}>
          {text}
        </Typography>
      </Stack>
    </Box>
  );
};

export default CommonLoader;
